import { SchemaApiValue, TrainedModel } from "../../@shared/Models/Models";

const initialDataModel = {
    countOfSchemas: 0 as number,
    models: undefined as SchemaApiValue[] | undefined,
    topSchemas: undefined as SchemaApiValue[] | undefined,
    isLoadingTopSchemas: false as boolean,
    isTrainedModelsLoading: false as boolean,
    openedModelId: "" as string,
    page: 1 as number,
    pageCount: 10 as number,
    isModelsLoading: false as boolean,
    openedSchema: undefined as SchemaApiValue | undefined,
    isLoadingOpenedSchema: false as boolean,
    openedSchemaModels: undefined as TrainedModel[] | undefined,
    isLoadingOpenedSchemaModels: false as boolean,
    isSchemaWasRemoved: false as boolean,
    openedModel: undefined as TrainedModel | undefined,
    isLoadingOpenedModel: false as boolean,
    isModelWasRemoved: false as boolean,
    isModelDuplicatedTo: undefined as string | undefined,
    searchValue: "" as string
}

export const initialState = {
    dataModel: initialDataModel,
}

export type DataStateType = typeof initialState;